import { rechargeApiRequest } from '../utils/request.js';
function listAddresses(session, query) {
  return rechargeApiRequest("get", `/addresses`, {
    query
  }, session);
}
async function getAddress(session, id, options) {
  const {
    address
  } = await rechargeApiRequest("get", `/addresses`, {
    id,
    query: {
      include: options?.include
    }
  }, session);
  return address;
}
async function createAddress(session, createRequest) {
  const {
    address
  } = await rechargeApiRequest("post", `/addresses`, {
    data: {
      customer_id: session.customerId ? Number(session.customerId) : void 0,
      ...createRequest
    }
  }, session);
  return address;
}
async function updateAddress(session, id, updateRequest) {
  const {
    address
  } = await rechargeApiRequest("put", `/addresses`, {
    id,
    data: updateRequest
  }, session);
  return address;
}
async function applyDiscountToAddress(session, id, discountCode) {
  return updateAddress(session, id, {
    discounts: [{
      code: discountCode
    }]
  });
}
async function removeDiscountsFromAddress(session, id) {
  return updateAddress(session, id, {
    discounts: []
  });
}
function deleteAddress(session, id) {
  return rechargeApiRequest("delete", `/addresses`, {
    id
  }, session);
}
async function mergeAddresses(session, mergeRequest) {
  const {
    address
  } = await rechargeApiRequest("post", `/addresses/merge`, {
    data: mergeRequest
  }, session);
  return address;
}
async function skipFutureCharge(session, id, skipRequest) {
  const {
    charge
  } = await rechargeApiRequest("post", `/addresses/${id}/charges/skip`, {
    data: skipRequest
  }, session);
  return charge;
}
export { applyDiscountToAddress, createAddress, deleteAddress, getAddress, listAddresses, mergeAddresses, removeDiscountsFromAddress, skipFutureCharge, updateAddress };